import { render, staticRenderFns } from "./form06c.vue?vue&type=template&id=3cb6d6b3&"
import script from "./form06c.vue?vue&type=script&lang=js&"
export * from "./form06c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports